import { render } from "./TextToSpeech.vue?vue&type=template&id=7f9c18f4&scoped=true"
import script from "./TextToSpeech.vue?vue&type=script&lang=js"
export * from "./TextToSpeech.vue?vue&type=script&lang=js"

import "./TextToSpeech.vue?vue&type=style&index=0&id=7f9c18f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9c18f4"]])

export default __exports__